import React from 'react';

const TimeIcon = ({ sx = {} }) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style={sx}>
      <path
        d="M8.00049 14C11.3142 14 14.0005 11.3137 14.0005 8C14.0005 4.68629 11.3142 2 8.00049 2C4.68678 2 2.00049 4.68629 2.00049 8C2.00049 11.3137 4.68678 14 8.00049 14Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.00049 5.6001V8.8001L10.4005 10.4001"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default TimeIcon;

